import { render, staticRenderFns } from "./tabProductTags.vue?vue&type=template&id=ebaf05e0&"
import script from "./tabProductTags.vue?vue&type=script&lang=js&"
export * from "./tabProductTags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports